import * as  React from 'react';
import { okButtonClass } from '../../../const/popupButtonClasses';

type PopupButtonProps = {
    label: string;
    action: () => void;
    className?: string;
    width?: number;
    title?: string;
}

export default function PopupButton({ label, action, className, width, title }: PopupButtonProps) {
    let style = {};
    if (width) {
        style = { width: `${width}px`, minWidth: `${width}px`, maxWidth: `${width}px` };
    }
    return <button
        style={style}
        className={`${okButtonClass} ${className}`}
        onClick={action}
        title={title}
    >
        {label}
    </button>;
}